import { render, staticRenderFns } from "./SubscriptionLivechat.vue?vue&type=template&id=ecbceef4"
import script from "./SubscriptionLivechat.vue?vue&type=script&lang=js"
export * from "./SubscriptionLivechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports